import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ZefForm, ZefFormsManagerService } from '@zerops/zef/forms';
import { FormState, disable, enable } from 'ngrx-forms';
import { FEATURE_NAME } from './project-env-edit-form.constant';
import { ProjectEnvTypes } from '@zerops/models/project';

export interface ProjectEnvEditFormValue {
  key: string;
  content: string;
  id: string;
  type: ProjectEnvTypes;
  sensitive: boolean;
}

export type ProjectEnvEditFormState = FormState<ProjectEnvEditFormValue>;

@Injectable({ providedIn: 'root' })
export class ProjectEnvEditForm extends ZefForm<ProjectEnvEditFormValue> {
  constructor(
    public store: Store<any>,
    public formsManager: ZefFormsManagerService
  ) {
    super(
      store,
      formsManager,
      FEATURE_NAME,
      {
        key: '',
        content: '',
        id: '',
        type: null,
        sensitive: false
      },
      {
        key: (s, ps) => {
          if (ps
              && ps.controls.type
              && ps.controls.type.value
              && ps.controls.type.value !== ProjectEnvTypes.User) {
            return disable(s);
          } else {
            return enable(s);
          }
        }
      }
    );
  }
}
